import * as STD                                from '@emersya/mpa-std';
import * as CM                                 from '@emersya/mpa-components-manager';
import {
	Section,
	Text
}                                              from '@emersya/mpa-components';
import ViewerComponent                         from '../../../Viewer/Viewer';

export interface IPlannerFurnitureCategoryTileComponentConfiguration extends Section.Configuration {
	objectsConfigurations: ApplicationNS.Configuration['PMS']['objects'];
	categoryConfiguration: ApplicationNS.Configuration['PMS']['productsAndObjectsCategories'][string];
	count: boolean;
	productTileId: string;
};

export class PlannerFurnitureCategoryTileComponent extends Section.Component<
	PlannerFurnitureCategoryTileComponent,
	IPlannerFurnitureCategoryTileComponentConfiguration
> {
	readonly plannerCategory!: ViewerComponent.ProductCategory;

	get products() {
		return <PlannerFurnitureProductTileNS.Component[]>this.component_find('@:content').component_outerChilds;
	};

	async update() {
		const CP = app.currentProduct;
		if (!CP || !CP.reference) {
			this.component_throwLibraryError('', {});
		}
		let hasSomeEnabledFurniture = false;
		for (const furniture of this.products) {
			const PC = this.component_configuration.objectsConfigurations.find(x => x.SKU === furniture.id);
			if (!PC) {
				this.component_throwLibraryError('', {});
			}
			if (app.areProductsSKURelatedToCurrentProduct(PC.context.forProducts)) {
				if (furniture.component_activation.preventedByConfiguration) {
					await furniture.component_enable();
				}
				hasSomeEnabledFurniture = true;
			} else {
				if (!furniture.component_activation.preventedByConfiguration) {
					await furniture.component_disable();
				}
			}
		}
		if (hasSomeEnabledFurniture) {
			if (this.component_activation.preventedByConfiguration) {
				await this.component_enable();
			}
		} else {
			if (!this.component_activation.preventedByConfiguration) {
				await this.component_disable();
			}
		}
	};

	override async component_start(ev: STD.events.Event<any, any>) {
		if (!app.viewer.planner) {
			this.component_throwUserError('', {});
		}
		(<any>this).plannerCategory = app.viewer.createCategory({
			name: this.id,
			menuActions: {
				edit: true,
				delete: true,
				rotate: true,
				duplicate: false
			},
			products: []
		});
		const content = this.component_find('@:content');
		let count = 0;
		for (const objectConfiguration of this.component_configuration.objectsConfigurations) {
			const furniture = await content.component_instantiateOuterChild<PlannerFurnitureProductTileNS.Configuration>(
				{
					type: this.component_configuration.productTileId,
					id: objectConfiguration.SKU,
					tree: this.component_tree,
					slot: null,
					isSlot: false,
					configuration: {
						objectConfiguration
					}
				}
			);
			await furniture.component_initialize();
			await furniture.component_start(ev);
			count++;
		}
		if (this.component_configuration.count) {
			const componentCount = <Text.Component>this.component_find('@:header.blockTitle.componentsCount');
			componentCount.update('(' + count.toString() + ')');
		}
		await super.component_start(ev);
		STD.translationsManager.update(this.component_DOM);
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IPlannerFurnitureCategoryTileComponentConfiguration
	) {
		STD.object.deepMergeAssign(configuration, [
			{
				'@innerConfigurations': {
					header: {
						'@innerConfigurations': {
							blockTitle: {
								'@innerConfigurations': {
									title: {
										'@translations': {
											text: configuration.categoryConfiguration.translations['@name']
										}
									}
								}
							}
						}
					}
				}
			}
		]);
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = PlannerFurnitureCategoryTileComponent;
	export type Component = PlannerFurnitureCategoryTileComponent;
	export type Configuration = IPlannerFurnitureCategoryTileComponentConfiguration;
}
import manifestXMLSource                       from './PlannerFurnitureCategoryTile.xml';
import './PlannerFurnitureCategoryTile.scss';
import { NS as ApplicationNS }                 from '../../../../Application/Application';
import { NS as PlannerFurnitureProductTileNS } from '../ProductTile/PlannerFurnitureProductTile';

CM.Manager.declare({
	id: 'viewer-planner-furniture-categoryTile',
	type: PlannerFurnitureCategoryTileComponent,
	manifest: manifestXMLSource
});
